const normalizeText = (value) => value.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();

class SkyaIngredientLibrary extends HTMLElement {
  connectedCallback() {
    this.items = [...this.querySelectorAll('[data-library-item]')].map((element) => ({
      element,
      letter: element.dataset.letter,
      text: normalizeText(element.dataset.search || '')
    }));
    this.letterButtons = [...this.querySelectorAll('[data-letter-button]')];
    this.searchInput = this.querySelector('[data-library-search]');
    this.status = this.querySelector('[data-library-status]');
    this.empty = this.querySelector('[data-library-empty]');

    this.letterButtons.forEach((button) => {
      button.addEventListener('click', () => this.selectLetter(button.dataset.letterButton));
    });
    this.searchInput.addEventListener('input', () => this.render());

    this.classList.add('is-enhanced');
    this.selectLetter(this.dataset.defaultLetter || 'all');
  }

  selectLetter(letter) {
    this.activeLetter = letter;
    this.searchInput.value = '';
    this.render();
  }

  matches(item, query) {
    if (query) return item.text.includes(query);
    return this.activeLetter === 'all' || item.letter === this.activeLetter;
  }

  render() {
    const query = normalizeText(this.searchInput.value.trim());
    let visible = 0;

    this.items.forEach((item) => {
      const isVisible = this.matches(item, query);
      item.element.hidden = !isVisible;
      if (isVisible) visible += 1;
    });

    this.letterButtons.forEach((button) => {
      button.setAttribute('aria-pressed', String(!query && button.dataset.letterButton === this.activeLetter));
    });

    this.empty.hidden = visible > 0;
    this.status.textContent = (this.dataset.statusTemplate || '')
      .replace('{count}', visible)
      .replace('{total}', this.dataset.total);
  }
}

if (!customElements.get('skya-ingredient-library')) {
  customElements.define('skya-ingredient-library', SkyaIngredientLibrary);
}
